import { Button } from '../../../../GlobalComponents/Button';
import { Flex } from '../../../../GlobalComponents/Flex';
import { Modal } from '../../../../GlobalComponents/Modal';

const StatusModal = ({
	isOpen,
	toggleHandler,
	message
}: StatusModalProps): JSX.Element => {
	return (
		<Modal isOpen={isOpen} toggleHandler={toggleHandler}>
			<Flex
				$flexDirection="column"
				$padding="12px 0"
				style={{ maxWidth: '370px' }}
			>
				<p style={{ lineHeight: '130%' }}>{message}</p>
				<Flex $justifyContent="flex-end">
					<Button onClick={toggleHandler}>Dismiss</Button>
				</Flex>
			</Flex>
		</Modal>
	);
};

export default StatusModal;

interface StatusModalProps {
	isOpen: boolean;
	toggleHandler: () => void;
	message: string;
}
